import { render, staticRenderFns } from "./ReceiptTemplate.vue?vue&type=template&id=2bed164b"
import script from "./ReceiptTemplate.vue?vue&type=script&lang=js"
export * from "./ReceiptTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports